import { render } from "./HeroiconsSolidFolderDownload.vue?vue&type=template&id=4e8090a6"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFolderDownload.vue"]])

export default __exports__